'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flex = require('./flex');

var _flex2 = _interopRequireDefault(_flex);

var _flex_item = require('./flex_item');

var _flex_item2 = _interopRequireDefault(_flex_item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//1.0.0 components

exports.default = {
    Flex: _flex2.default,
    FlexItem: _flex_item2.default
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-weui/lib/components/flex/index.js
// module id = 1741
// module chunks = 7